/* ==========================================================================
   Koolseed — S.S.S. listesi

   Tasarımdaki davranış: kategori şeridi listeyi süzüyor, kartlardan aynı anda
   yalnızca biri açık kalıyor ve listenin ilk kartı açık geliyor. Kategori
   değişince yine ilk kart açılıyor.

   Açılma yüksekliği ölçülerek veriliyor (sabit bir max-height uzun cevapları
   kırpardı): açarken 0 → içerik yüksekliği, geçiş bitince `auto` bırakılıyor
   ki sonradan değişen içerik kırpılmasın.
   ========================================================================== */

(function () {
  'use strict';

  class KsFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
      this.empty = this.querySelector('[data-faq-empty]');
      this.cats = Array.from(this.querySelectorAll('[data-faq-cat]'));
      this.cat = '';
      if (!this.items.length) return;

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-faq-toggle]');
        if (toggle && this.contains(toggle)) {
          this.toggle(toggle.closest('[data-faq-item]'));
          return;
        }
        const button = event.target.closest('[data-faq-cat]');
        if (button && this.contains(button)) this.select(button);
      });

      this.filter();
    }

    select(button) {
      this.cat = button.dataset.faqCat;
      this.cats.forEach((b) => {
        const on = b === button;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      this.filter();
    }

    filter() {
      let first = null;
      this.items.forEach((item) => {
        const show = !this.cat || item.dataset.cat === this.cat;
        item.hidden = !show;
        if (show && !first) first = item;
        if (!show) this.close(item, true);
      });
      if (this.empty) this.empty.hidden = Boolean(first);
      // Tasarımda liste her zaman ilk kart açık başlıyor.
      if (first) this.open(first, true);
    }

    toggle(item) {
      if (!item) return;
      const expanded = item.querySelector('[data-faq-toggle]').getAttribute('aria-expanded') === 'true';
      if (expanded) this.close(item);
      else this.open(item);
    }

    open(item, instant) {
      this.items.forEach((other) => { if (other !== item) this.close(other, true); });

      const button = item.querySelector('[data-faq-toggle]');
      const panel = item.querySelector('[data-faq-panel]');
      if (!button || !panel) return;
      if (button.getAttribute('aria-expanded') === 'true') return;

      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;

      if (instant) { panel.style.height = 'auto'; return; }

      panel.style.height = '0px';
      // Ölçüm için bir kare bekle: `hidden` kalkmadan scrollHeight 0 gelir.
      window.requestAnimationFrame(() => {
        panel.style.height = panel.scrollHeight + 'px';
        const done = () => {
          panel.removeEventListener('transitionend', done);
          if (button.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        };
        panel.addEventListener('transitionend', done);
      });
    }

    close(item, instant) {
      const button = item.querySelector('[data-faq-toggle]');
      const panel = item.querySelector('[data-faq-panel]');
      if (!button || !panel) return;
      if (button.getAttribute('aria-expanded') !== 'true') return;

      button.setAttribute('aria-expanded', 'false');

      if (instant) {
        panel.hidden = true;
        panel.style.height = '';
        return;
      }

      // `auto`dan animasyon olmaz: önce ölçülen yüksekliğe sabitle.
      panel.style.height = panel.scrollHeight + 'px';
      window.requestAnimationFrame(() => { panel.style.height = '0px'; });
      const done = () => {
        panel.removeEventListener('transitionend', done);
        if (button.getAttribute('aria-expanded') === 'false') panel.hidden = true;
      };
      panel.addEventListener('transitionend', done);
    }
  }

  if (!customElements.get('ks-faq')) customElements.define('ks-faq', KsFaq);
})();
